import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay/legacy';

import { Breadcrumbs } from 'dibs-elements/exports/Breadcrumbs';

// helpers
import get from 'lodash.get';
import { trackBreadcrumbClick } from './breadcrumbTracking';
function PdpRespBreadcrumbsComponent(props) {
    const breadcrumbs = get(props, 'item.breadcrumbs') || [];

    const handleBreadcrumbClick = e => {
        const index = breadcrumbs.findIndex(({ path }) => {
            return path === e.target.pathname;
        });
        const trackingKey = index === 0 ? 'home' : `l${index}`;
        trackBreadcrumbClick(trackingKey, e);
    };

    return (
        <Breadcrumbs breadcrumbs={breadcrumbs} onClick={handleBreadcrumbClick} isLastItemActive />
    );
}

PdpRespBreadcrumbsComponent.propTypes = {
    item: PropTypes.object,
};

export const PdpRespBreadcrumbs = createFragmentContainer(PdpRespBreadcrumbsComponent, {
    item: graphql`
        fragment PdpRespBreadcrumbs_item on Item {
            breadcrumbs {
                text
                path
                isLinkable
            }
        }
    `,
});
